import { React, useContext, useState } from "react";

import ThemeContext from "../../lib/theme-context";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

const CustomSelect = ({
  size,
  inputLabel,
  value,
  label,
  onChange,
  menuItemArray,
  placeholder,
  sx,
  variant = "default",
  disabled,
}) => {
  const isCompact = variant === "compact";
  const theme = useContext(ThemeContext);
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <FormControl size={size} sx={{ width: "100%", height: isCompact ? "40px" : "50px", ...sx }} disabled={disabled}>
      <InputLabel
        sx={{
          color:
            theme[0] === "dark"
              ? "#FCFCFF !important"
              : "rgba(37,37,37) !important",
          borderOutline:
            theme[0] === "dark"
              ? "#FCFCFF !important"
              : "rgba(37,37,37) !important",
        }}
      >
        {inputLabel}
      </InputLabel>

      <Select
        disabled={disabled}
        MenuProps={{
          sx: {
            zIndex: 99999,
          },
          PaperProps: {
            sx: {
              bgcolor: theme[0] === "dark" ? "rgba(40, 42, 46)" : "#FCFCFF",
              maxHeight: "450px",

              "& .MuiMenuItem-root": {
                padding: 1.5,
                justifyContent: "center",
              },
            },
          },
        }}
        defaultValue=""
        fullWidth
        open={menuOpen}
        onOpen={() => setMenuOpen(true)}
        onClose={() => {
          setTimeout(() => setMenuOpen(false), 200);
        }}
        sx={isCompact ? {
          backgroundColor: theme[0] === "dark" ? "#3a3d45" : "#e5e7eb",
          color: theme[0] === "dark" ? "#FCFCFF" : "#1f2937",
          borderRadius: menuOpen ? "12px 12px 0 0" : "12px",
          fontSize: "13px",
          fontWeight: 600,
          transition: "border-radius 0.2s ease-in-out",
          ".MuiSvgIcon-root": {
            fill: theme[0] === "dark" ? "#FCFCFF" : "#1f2937",
          },
          "& fieldset": {
            border: "none",
          },
          "&:hover": {
            backgroundColor: theme[0] === "dark" ? "#434650" : "#d1d5db",
          },
          "&:hover fieldset": {
            border: "none",
          },
          "&.Mui-focused": {
            backgroundColor: theme[0] === "dark" ? "#3a3d45" : "#e5e7eb",
          },
          "&.Mui-focused fieldset": {
            border: "none",
          },
          "& .MuiSelect-select": {
            paddingTop: "6px",
            paddingBottom: "6px",
            paddingLeft: "10px",
            paddingRight: "10px",
          },
        } : {
          backgroundColor: theme[0] === "dark" ? "#3a3d45" : "#e5e7eb",
          color: theme[0] === "dark" ? "#FCFCFF" : "#1f2937",
          borderRadius: menuOpen ? "12px 12px 0 0" : "12px",
          fontSize: "16px",
          fontWeight: 600,
          transition: "border-radius 0.2s ease-in-out",
          ".MuiSvgIcon-root": {
            fill: theme[0] === "dark" ? "#FCFCFF" : "#1f2937",
          },
          "& fieldset": {
            border: "none",
          },
          "&:hover": {
            backgroundColor: theme[0] === "dark" ? "#434650" : "#d1d5db",
          },
          "&:hover fieldset": {
            border: "none",
          },
          "&.Mui-focused": {
            backgroundColor: theme[0] === "dark" ? "#3a3d45" : "#e5e7eb",
          },
          "&.Mui-focused fieldset": {
            border: "none",
          },
          "& .MuiSelect-select": {
            paddingTop: "8px",
            paddingBottom: "8px",
            paddingLeft: "12px",
            paddingRight: "12px",
          },
        }}
        value={value}
        label={label}
        onChange={onChange}
        displayEmpty
        renderValue={(selected) => {
          if (!selected || selected === "") {
            return (
              <span style={{ 
                color: theme[0] === "dark" ? "#9ca3af" : "#6b7280",
                fontWeight: 600
              }}>
                {placeholder || ""}
              </span>
            );
          }
          const parsedItems = JSON.parse(menuItemArray || "[]");
          const selectedItem = parsedItems.find(item => item.value === selected);
          if (selectedItem) {
            // Extract just the balance number from the label (format: "Account Name - $balance")
            const balanceMatch = selectedItem.label.match(/\$(\d+\.?\d*)/);
            return balanceMatch ? `$${balanceMatch[1]}` : selectedItem.label;
          }
          return "";
        }}
      >
        {JSON.parse(menuItemArray).map((item, index) => {
          return (
            <MenuItem
              key={item + index}
              sx={{
                color: theme[0] === "dark" ? "#FCFCFF" : "rgba(40, 42, 46)",
              }}
              value={item.value}
            >
              {item.label}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default CustomSelect;
